$ = require 'jquery'
View = require 'app/scripts/views/internal/view'
{ trackUe } = require '@trello/analytics'
_ = require 'underscore'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
TrelloEmojiPicker = require 'app/scripts/views/emoji/trello-emoji-picker'
{ ReactRootComponent } = require 'app/scripts/views/internal/react-root-component'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class ReactionSelector extends View
  initialize: ->
    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

  render: ->
    # render the picker within the popover we selected for it
    ReactDOM.render(@getEmojiPicker(), @$el[0])
    @trackReactionClickEvents()
    @

  remove: ->
    ReactDOM.unmountComponentAtNode(@$el[0])
    super

  trackWithData: (verb, dirObj, prepObj, indObj, method) =>
    { category } = @options.trackingContext
    actionData = JSON.stringify _.omit(@options.trackingContext, 'category')

    trackUe(category, verb, dirObj, prepObj, indObj, method, actionData)

  trackReactionClickEvents: ->
    # Using these events to handle emoji mart click tracking events until
    # necessary PRs can be put into place for event handlers
    selectors = '.emoji-mart, .emoji-mart-anchor, .emoji-mart-skin-swatch-selected, .emoji-mart-skin-swatches-opened .emoji-mart-skin'
    $(document).off('click', selectors).on('click', selectors, (e) =>
      e.stopPropagation()
      $currentTarget = $(e.currentTarget)
      isCategorySelector = $currentTarget.is('.emoji-mart-anchor')

      target = if isCategorySelector
          'reaction selector category button'
        else if $currentTarget.is('.emoji-mart-skin-swatch')
          'reaction selector skin tone button'
        else if $currentTarget.is('.emoji-mart-skin')
          'reaction selector skin tone menu'
      if !target then return
      method = "by clicking the #{ target }"

      dirObj = if isCategorySelector then 'reaction selector category' else 'reaction selector skin tone menu'

      prepObj =
        if isCategorySelector
          $currentTarget.attr('title')
        else if $currentTarget.is('.emoji-mart-skin')
          "skin-tone-#{$currentTarget.data('skin')}"
        else
          ''

      if @sendGASEvent
        Analytics.sendUIEvent
          action: 'clicked',
          actionSubject: 'icon',
          actionSubjectId: 'reactionMenuIcon',
          source: 'reactionSelectorInlineDialog',
          attributes:
            target: target
          containers:
            card: { id: @options?.trackingContext?.cardId || '' }
            board: { id: @options?.trackingContext?.boardId || '' }
            list: { id: @options?.trackingContext?.listId || '' }

      @trackWithData 'opens', dirObj, prepObj, '', method
    )
    $(document).on(
      'input',
      '.emoji-mart-search input',
      _.debounce (e) =>
        e.stopPropagation()
        $currentTarget = $(e.currentTarget)
        if @sendGASEvent
          Analytics.sendTrackEvent
            action: 'searched'
            actionSubject: 'reaction'
            source: 'reactionSelectorInlineDialog'
            containers:
              card: { id: @options?.trackingContext?.cardId || '' }
              board: { id: @options?.trackingContext?.boardId || '' }
              list: { id: @options?.trackingContext?.listId || '' }
        @trackWithData 'searches', 'reaction selector', '', 'for emoji', 'by typing in the reaction selector search box'
      , 1000
    )

  handleReactionClick: (e, emoji) ->
    trackFn = (isAdded) =>
      method =
        'by picking a reaction'
      if @sendGASEvent
        Analytics.sendUIEvent
          action: 'clicked',
          actionSubject: 'reaction',
          actionSubjectId: 'commentReaction'
          source: 'reactionSelectorInlineDialog',
          attributes:
            emoji: emoji.id
            added: isAdded
            removed: !isAdded
          containers:
            card: { id: @options?.trackingContext?.cardId || '' }
            board: { id: @options?.trackingContext?.boardId || '' }
            list: { id: @options?.trackingContext?.listId || '' }

      @trackWithData(
        if isAdded then 'adds' else 'removes',
        'reaction',
        emoji.id,
        if isAdded then 'to a comment' else 'from a comment',
        method,
      )

    @options.reactionList.toggleReaction(@options.actionId, emoji, trackFn)
    @options.onReactionClick && @options.onReactionClick(e, emoji)

  getEmojiPicker: ->
    React.createElement TrelloEmojiPicker,
      onClick: (emoji, e) => @handleReactionClick(e, emoji)

  willBePopped: ->
    $('.js-open-reactions').removeClass 'active'
    $(document).off('click', '.emoji-mart, .emoji-mart-anchor, .emoji-mart-skin-swatch-selected, .emoji-mart-skin-swatches-opened .emoji-mart-skin')
    $(document).off('input', '.emoji-mart-search input')
